import React from 'react';
import {useTranslation} from "react-i18next";
import {Text} from "../../../index";

const YourPersonalAssistant = () => {
    const {t} = useTranslation();
    const aiChat = document.querySelector('.chat')?.getBoundingClientRect();

    return (
        <div className="meeting-step" style={{width: aiChat?.left - 100, whiteSpace: 'break-spaces'}}>
            <Text size="f16" font="book" color="black">{t('tour_step_5_desc')}</Text>
        </div>
    );
};

export default YourPersonalAssistant;